import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";

export const AvbestillFeilet = () => {
  const { t } = useTranslation();
  return (
    <Alert data-color="danger">
      <div className="flex flex-col gap-2">
        <Heading level={2} data-size="xs">
          {t("pages.avtaler.avbestilling.alert-feilet-tittel")}
        </Heading>
        <Paragraph>
          {t("pages.avtaler.avbestilling.alert-feilet-beskrivelse")}
        </Paragraph>
      </div>
    </Alert>
  );
};
